export default {
  SET_FOLLOWER_COUNTS: 'followers/SET_FOLLOWER_COUNTS',
  INCREASE_FOLLOWINGS_COUNTER: 'followers/INCREASE_FOLLOWINGS_COUNTER',
  INCREASE_FOLLOWERS_COUNTER: 'followers/INCREASE_FOLLOWERS_COUNTER',
  REDUCE_FOLLOWINGS_COUNTER: 'followers/REDUCE_FOLLOWINGS_COUNTER',
};
